import { render, staticRenderFns } from "./SimulacaoEditGarantia.vue?vue&type=template&id=3563fe6d"
import script from "./SimulacaoEditGarantia.vue?vue&type=script&lang=js"
export * from "./SimulacaoEditGarantia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports